import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// import { AppState } from '@capacitor/app';
import { failedTransaction, setLoadingSpinner } from '../actions/shared.action';
import { catchError, exhaustMap, filter, map, mergeMap, of, tap } from 'rxjs';
import { ROUTER_NAVIGATION, RouterNavigatedAction } from '@ngrx/router-store';
import * as fromGameActions from '../actions/game.action'
import { APIResponse } from 'src/app/models/api-response.model';
import { Router } from '@angular/router';
import { ModalService } from 'src/app/services/modal.service';
import { AppState } from '../app.state';
import { GameService } from 'src/app/services/game.service';
import * as fromTournamentAction from '../../store/actions/tournament.action'

@Injectable()
export class GameEffects {

  getCasualGames$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/casual-game-list');
      }),
      exhaustMap((action) =>
        this.gameService.getCasualGames().pipe(
          map((response) => { 
            console.log('getCasualGames$', response);
            return fromGameActions.getCasualGamesSuccess({ data: response?.details});
          }),
          catchError((response) => {
            return of(fromGameActions.getCasualGamesFailed({ data: response.error }));
          })
        )
      )
    )
  });

  reloadCasualGames$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromGameActions.getCasualGames),
      mergeMap(() => {
        return this.gameService.getCasualGames().pipe(
          map((response: APIResponse) => {           
            console.log('reloadCasualGames$', response);
            return fromGameActions.getCasualGamesSuccess({ data: response?.details});
          }),
          catchError((response) => {
            return of(fromGameActions.getCasualGamesFailed({ data: response.error }));
          })
        );
      })
    )
  );

  getCasualGamesSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromGameActions.getCasualGamesSuccess),
        tap(async (action) => {
          console.log('getCasualGamesSuccess$', action.data);
        })
      ),
    { dispatch: false }
  );

  getCasualGamesFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromGameActions.getCasualGamesFailed),
        tap((action) => {
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.errorModal(error);
          console.log('getCasualGamesFailed$', action.data);
        })
      ),
    { dispatch: false }
  );

  endCasualGame$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromGameActions.endCasualGame),
      mergeMap((action) => {
        return this.gameService.endCasualGame(action.data).pipe(
          map((response: APIResponse) => {           
            console.log('endCasualGame$', response);
            return fromGameActions.endCasualGameSuccess({ data: response?.details});
          }),
          catchError((response) => {
            return of(fromGameActions.endCasualGameFailed({ data: response.error }));
          })
        );
      })
    )
  );

  endCasualGameSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromGameActions.endCasualGameSuccess),
        tap(async (action) => {
          this.store.dispatch(fromGameActions.getCasualGames());
          console.log('endCasualGameSuccess$', action.data);
          const success = {
            message: 'End Casual Game Success'
          }
          this.modalService.successModal(success);
          this.modalService.hideLoadingSpinner();
        })
      ),
    { dispatch: false }
  );

  endCasualGameFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromGameActions.endCasualGameFailed),
        tap((action) => {
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.errorModal(error);
          this.modalService.hideLoadingSpinner();
          console.log('endCasualGameFailed$', action.data);
        })
      ),
    { dispatch: false }
  );

  endLeagueGame$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromGameActions.endLeagueGame),
      mergeMap((action) => {
        return this.gameService.endLeagueGame(action.data, action?.game?.gameId).pipe(
          map((response: APIResponse) => {           
            console.log('endLeagueGame$', response);
            return fromGameActions.endLeagueGameSuccess({ data: response?.details, league: action?.league});
          }),
          catchError((response) => {
            return of(fromGameActions.endLeagueGameFailed({ data: response.error }));
          })
        );
      })
    )
  );

  endLeagueGameSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromGameActions.endLeagueGameSuccess),
        tap(async (action) => {
          this.store.dispatch(fromGameActions.getCasualGames());
          this.modalService.hideUpdateLeagueGame();
          console.log('endLeagueGameSuccess$', action.data);
          const success = {
            message: 'End League Game Success'
          }
          this.store.dispatch(fromTournamentAction.getLeagueGames({data: action?.league?.leagueId, league: action?.league, redirect: true}))
          this.modalService.hideLoadingSpinner();
          this.modalService.successModal(success);
        })
      ),
    { dispatch: false }
  );

  endLeagueGameFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromGameActions.endLeagueGameFailed),
        tap((action) => {
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.errorModal(error);
          this.modalService.hideLoadingSpinner();
          console.log('endLeagueGameFailed$', action.data);
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private gameService: GameService,
    private router: Router,
    private modalService: ModalService,
    private store: Store<AppState>
    // private store: Store<AppState>,
  ) {}

}
